<a #topOfPage id="topOfPage"></a>

<div class="progress-bar-page">
  @if (!isEditFromReview) {
    <div class="progress-bar-header">
      <app-progress-bar
        [currentStep]="currentStep"
        [totalSteps]="totalSteps"
        [completedSteps]="completedSteps"
        (stepChanged)="goToStep($event)"
      ></app-progress-bar>
    </div>
  }
  <div class="progress-bar-page-container">
    @if (currentStep === 1) {
      <div>
        <app-employee-info
          (val)="handleUserSubmit($event)"
          (cancelEmitter)="onCancel()"
          [parentForm]="mhs"
        ></app-employee-info>
      </div>
    }
    @if (currentStep === 2) {
      <div>
        <app-applicant-info
          (val)="handleUserSubmit($event)"
          (cancelEmitter)="onCancel()"
          (backEmitter)="goToPreviousStep()"
          [showBackButton]="true"
          [parentForm]="mhs"
        ></app-applicant-info>
      </div>
    }
    @if (currentStep === 3) {
      <div>
        <app-med-history
          (val)="handleUserSubmit($event)"
          (cancelEmitter)="onCancel()"
          (backEmitter)="goToPreviousStep()"
          [showBackButton]="true"
          [parentForm]="mhs"
        ></app-med-history>
      </div>
    }
    @if (currentStep === 4) {
      <div>
        <app-physician-info
          (val)="submitApplication($event)"
          (cancelEmitter)="onCancel()"
          (backEmitter)="goToPreviousStep()"
          [showBackButton]="true"
          [parentForm]="mhs"
        ></app-physician-info>
      </div>
    }
    <!-- @if (currentStep === 5) {
      <div>
        <app-auth-sign
          (val)="handleSubmitApplication($event)"
          [parentForm]="mhs"
          (cancelEmitter)="onCancel()"
          (backEmitter)="goToPreviousStep()"
          [showBackButton]="true"
        ></app-auth-sign>
      </div>
    } -->
    <!-- @if (currentStep === 6) {
      <div>
        <app-electronic-communication
          (val)="submitApplication($event)"
          [parentForm]="mhs"
          (cancelEmitter)="onCancel()"
          (backEmitter)="goToPreviousStep()"
          [showBackButton]="true"
        ></app-electronic-communication>
      </div>
    } -->
  </div>
</div>

<prism-ui-modal key-id="cancel-modal" has-dark-overlay="true">
  <prism-ui-heading
    slot="modal-header"
    key-id="cancel-modal"
    font-size="sm"
    font-weight="strong"
    >{{ modalContentHeading }}</prism-ui-heading
    >
    <prism-ui-copy slot="modal-body" key-id="cancel-modal">
      {{ modalContentBody }}
    </prism-ui-copy>
    <div slot="modal-footer">
      <div class="modalButtonStyling">
        <prism-ui-button
          button-width="full"
          key-id="cancel-button"
          size="md"
          variant="secondary"
          type="button"
          is-icon-right-aligned="false"
          (click)="onCancelModal('prism-ui-modal-cancel-modal')"
          >Cancel</prism-ui-button
          >
          <prism-ui-button
            class="leftPaddingSmall"
            button-width="full"
            key-id="continue-button"
            size="md"
            variant="primary"
            type="button"
            is-icon-right-aligned="false"
            (click)="leaveAnyway()"
            >Leave Anyway</prism-ui-button>
        </div>
    </div>
</prism-ui-modal>
